import { useMemo } from 'react';
import { useAppContext } from 'src/AppContextProvider';
import { useLocalStorage } from 'src/domain/useLocalStorage';
import { EVENT_TRACKING_PAGE_CONST } from './consts';

export const useEventTrackingSidebar = () => {
    const { isFiltersSidebarEnabled } = useAppContext();

    const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorage(EVENT_TRACKING_PAGE_CONST.localStorage.sidebarCollapseKey, false);

    const layoutPaddingLeft = useMemo(() => {
        if (!isFiltersSidebarEnabled) return '0';

        return sidebarCollapsed ? '35px' : '200px';
    }, [isFiltersSidebarEnabled, sidebarCollapsed]);

    return {
        sidebarCollapsed,
        setSidebarCollapsed,
        layoutPaddingLeft,
        isFiltersSidebarEnabled,
    };
};
